const ITEMS = [
  "CNC Machining",
  "Turning",
  "Milling",
  "Grinding",
  "Surface Grinding",
  "Tool & Die Manufacturing",
  "Custom Components",
  "Est. 1995 — Hyderabad, India",
];

const Marquee = () => (
  <div data-testid="capability-marquee" className="bg-[#0B1329] border-y border-slate-800 py-4 overflow-hidden">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span
              key={`${dup}-${item}`}
              className="flex items-center text-xs font-semibold uppercase tracking-[0.25em] text-slate-400"
            >
              <span className="px-8">{item}</span>
              <span className="h-1.5 w-1.5 bg-[#2563EB]" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
